import {
    CLEAR_SEARCH_FREELANCERS, EMPTY_FREELANCERS, SEARCH_FREELANCERS,
    SEARCH_FREELANCERS_SUCCESS, SEARCH_FREELANCERS_FAILURE, SET_FREELANCERS_SEARCH_FIELD,
    SET_FREELANCERS_FILTERS
} from "./constants";

import clone from 'clone';

const emptyFilters = {
    experienceIds: [],
    specializationIds: []
}

const initialState = {
    error: {},
    filters: clone(emptyFilters),
    isFetching: false,
    searchResults: [],
    searchTerm: ''
};

function freelancersReducer(state = clone(initialState), action) {
    switch(action.type) {
        case CLEAR_SEARCH_FREELANCERS: 
            return Object.assign({}, state, {
                searchResults: []
            });
        case EMPTY_FREELANCERS:
            return clone(initialState);
        case SEARCH_FREELANCERS:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case SEARCH_FREELANCERS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                searchResults: action.data
            });
        case SEARCH_FREELANCERS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SET_FREELANCERS_SEARCH_FIELD:
            return Object.assign({}, state, {
                searchTerm: action.data
            });
        case SET_FREELANCERS_FILTERS:
            return Object.assign({}, state, {
                filters: action.data
            })
        default:
            return state;
    }
}

export default freelancersReducer;


// WEBPACK FOOTER //
// ./src/containers/Freelancers/store/reducers.js